import { graphql } from 'react-relay';

export const performanceByYearLineItemFragment = graphql`
    fragment PerformanceByYearLineItem_component on PerformanceByYearLineItem {
        period
        development
    }
`;
